import React, {Fragment} from 'react'


const Product_description = (props) => {
    return (
        <Fragment>
            <div className="text-center">
                <a href={`${props.partner_url}`} target="_blank" rel="noopener noreferrer">
                <img src={`/images/company_logos/${props.image}.jpg`} alt="molemab_logo" id="partner_logos" style={{width: `${props.image_width}`, height: `${props.image_height}`}} className={props.className}/>
                </a>
            </div>
            <div className="text-left font-medium pt-3 px-3">
                <p>{props.description}</p>
            </div>
            <div className="border-b pt-3 border-gray-400"></div>
            <div className="text-left pt-4 text-center">
                    <h1 className="text-3xl font-bold">제품 소개</h1>
            </div>
        </Fragment>
    )
}

export default Product_description
